import _getFieldInfo from './_getFieldInfo';
import _getSortedImportedFields from './_getSortedImportedFields';

/**
 * Used to expand bottlebooksFieldsMap multiples fields
 * @param {object} bottlebooksFieldsMap
 * @returns
 */
export default _expandColumnsMapping;
function _expandColumnsMapping(bottlebooksFieldsMap) {
  // Following was happeining. This is why implementation is more complex because we need to cleanup indices.
  //   {
  //     "bottlebooksFieldName": "product.tastingNotes.1.rating",
  //     "importFieldName": "product.tastingNotes.10.rating",
  // }
  const multiplesIndex = {};
  const multipleCounts = {};
  const multipleLastIndex = {};
  // Grouping children of multiples. We need to know if any of the children properties has been mapped.
  // If not we know we have to chnage mapped field index.
  // {product.parent.0: true, product.parent.1: false, ...}

  Object.keys(bottlebooksFieldsMap).forEach((importFieldName) => {
    const { bottlebooksFieldName } = bottlebooksFieldsMap[importFieldName];
    const { index, baseNameWithIndex, isMulti } =
      _getFieldInfo(importFieldName);
    if (isMulti) {
      if (!multiplesIndex[baseNameWithIndex])
        multiplesIndex[baseNameWithIndex] = false;
      multiplesIndex[baseNameWithIndex] =
        multiplesIndex[baseNameWithIndex] || !!bottlebooksFieldName;
    }
  });
  // console.log(multiplesIndex);
  const sorted = _getSortedImportedFields(bottlebooksFieldsMap);

  return sorted.reduce((acc, { bottlebooksFieldName, importFieldName }) => {
    // const { bottlebooksFieldName } = bottlebooksFieldsMap[importFieldName];
    const { index, baseName, baseNameWithIndex, isMulti, childName } =
      _getFieldInfo(importFieldName);
    // let field = bottlebooksFieldsMap[importFieldName];
    // const { bottlebooksFieldName } = field;
    if (!bottlebooksFieldName) {
      // no mapping
      // no change
      acc.push({ bottlebooksFieldName, importFieldName });
      return acc;
    }

    if (isMulti) {
      if (!multipleCounts[baseName]) multipleCounts[baseName] = 0;
      let count = multipleCounts[baseName] || 0;
      if (!multiplesIndex[baseNameWithIndex]) {
        // none of the children under current index were mapped. Skipping
        acc.push({ bottlebooksFieldName, importFieldName });
      } else {
        const lastIndex = multipleLastIndex[baseName] || 0;
        if (index > lastIndex) {
          multipleLastIndex[baseName] = index;
          multipleCounts[baseName]++;
          count++;
        }
        const updatedBBFieldName = [baseName, count, childName].join('.');
        acc.push({
          importFieldName,
          bottlebooksFieldName: updatedBBFieldName,
        });
      }
    } else {
      acc.push({ bottlebooksFieldName, importFieldName });
    }
    return acc;
  }, []);
}
